import { UserAuthModel } from '../models/user-auth.model';
import { UserAuthUIModel } from '../ui-models/user-auth.ui-model';

function mapToUI(userData: UserAuthModel): UserAuthUIModel {
  return {
    accessToken: userData.data.accessToken,
    tokenExpiresIn: userData.data.tokenExpiresIn,
    email: userData.data.email,
    userId: userData.data.userId,
    role: userData.data.role
  };
}

export default {
  mapToUI
};
